exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".client-select .dropdown{list-style:none;max-width:350px;color:#1e212a;border:1px solid rgba(0,0,0,.15);border-radius:4px;padding:3px 2px 2px 6px}.client-select .dropdown a{color:#1e212a}.client-select .dropdown a.dropdown-toggle:after{margin-top:.5em;margin-left:10px}.client-select .dropdown .dropdown-menu{margin-top:8px;border-radius:4px;width:100%;max-height:35vh;overflow:auto}.client-select .dropdown .dropdown-item:active{background-color:#1e212a;color:#fff}", ""]);

// exports
